













































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class AnamnesisDokter extends Vue {
  @Prop() title = "Anamnesis Dokter";

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  keluhanUtama = null;
  riwayatPenyakitDahulu = null;
  riwayatPenyakitSekarang = null;

  get registerId() {
    return "";
  }

  get storeAnannesisDokter() {
    // dummy first
    return {
      status: true,
      loading: false
    };
  }

  getAnamnesis() {
    // get anamnesis dokter by store
  }

  saveAnamnesis() {
    if (this.readOnly) return;
    //
  }
}
